module.exports = __webpack_public_path__ + "img/img_map_pc@3x.91c8a914.png";